const queueUtils = {
  isPassStatusQueue: (pass) => {
    if (Boolean(pass?.is_queue_pass) === true) {
      return true
    }
    return false
  },
  shouldPlayNotification: (context) => {
    const { eventType, payload, user, role, userId, store } = context

    if (!user?.audio_enabled) {
      return false
    }

    return queueUtils._checkNotificationByEvent(
      eventType,
      payload,
      role,
      userId,
      store
    )
  },
  shouldReceiveUpdate: (context) => {
    const {
      payload,
      userId,
      store,
      skipNotifyCheck = false,
      routeCheck = null // object with { requiredRoute, currentRoute } or null
    } = context

    if (routeCheck && routeCheck.currentRoute !== routeCheck.requiredRoute) {
      return false
    }

    const queueAccess = queueUtils._getQueueAccess(store)

    if (skipNotifyCheck) {
      return queueAccess.isAllTabOpen || queueAccess.isMyTabOpen
    }

    const shouldNotifyUser = queueUtils._shouldNotifyUser(payload, userId)

    return (
      queueAccess.isAllTabOpen || (queueAccess.isMyTabOpen && shouldNotifyUser)
    )
  },
  _checkNotificationByEvent: (eventType, payload, role, userId, store) => {
    switch (eventType) {
      case "QueuePassCreated":
      case "QueuePassMoved":
      case "QueuePassCanceled":
      case "QueuePassConverted": {
        return Boolean(role === "student" && payload?.notifyStudent)
      }
      case "AdminQueuePassCreated":
      case "AdminQueuePassConverted": {
        const queueAccess = queueUtils._getQueueAccess(store)
        const shouldNotifyUser = queueUtils._shouldNotifyUser(payload, userId)

        return (
          queueAccess.isAllTabOpen ||
          (queueAccess.isMyTabOpen && shouldNotifyUser)
        )
      }
      default:
        return false
    }
  },
  _getQueueAccess: (store) => {
    return {
      isAllTabOpen:
        store.getters["dashboardTable/isQueueStatusAndAllTypeSelected"],
      isMyTabOpen:
        store.getters["dashboardTable/isQueueStatusAndMyTypeSelected"]
    }
  },
  _shouldNotifyUser: (payload, userId) => {
    return (
      Array.isArray(payload?.notifyAdultsIds) &&
      payload?.notifyAdultsIds?.includes(userId)
    )
  }
}

export default queueUtils
